import {
  AllClassifierCategoriesQueryParams,
  useAllClassifierCategoriesQuery,
} from '../../../../classifier';
import { DataObjectDimensionType } from '../../../types';
import { AlgorithmSourceDimensionFormDataType } from '../../sources/schema/types';

export const useAlgorithmSourceDimensionCategoriesQuery = (
  dimension?: AlgorithmSourceDimensionFormDataType
) => {
  const {
    classifier,
    allCategories,
    category,
    levelNumber,
    dimensionTypeCode,
    code,
  } = dimension || {};

  const classifierCode =
    dimensionTypeCode === DataObjectDimensionType.SUBJECT_ATTRIBUTE
      ? code
      : classifier?.code;

  return useAllClassifierCategoriesQuery(
    {
      classifierCode,
      ...(allCategories && { categoryType: 'category' }),
      ...(category && { categoryGroupOrCombinedGroupCode: category.code }),
      ...(levelNumber && { levelNumber }),
    } as AllClassifierCategoriesQueryParams,
    { enabled: Boolean(classifierCode) }
  );
};
